// Catálogo de amenities/comodidades predefinidas para agendas (cualquier rubro).
// Mismo patrón que rubro-catalog.ts: un catálogo central, ampliable sumando entradas.
// Cada agenda guarda su propia lista (Professional.amenities) como array de AmenityItem;
// los predefinidos referencian un id de acá, los custom llevan su propio texto libre.

import {
  Accessibility,
  AirVent,
  Baby,
  Coffee,
  CreditCard,
  Camera,
  Cross,
  Dog,
  Dumbbell,
  Flame,
  ShowerHead,
  Shirt,
  Sparkles,
  SquareParking,
  Wifi,
  type LucideIcon,
} from "lucide-react";

export type AmenityTipo = "predefinido" | "custom";

export type AmenityItem = {
  id: string;
  nombre: string;
  icono: string;
  tipo: AmenityTipo;
};

export type AmenityCatalogEntry = {
  id: string;
  nombre: string;
  icono: string;
};

export const AMENITIES_CATALOG: AmenityCatalogEntry[] = [
  { id: "wifi", nombre: "WiFi", icono: "wifi" },
  { id: "estacionamiento", nombre: "Estacionamiento", icono: "parking" },
  { id: "vestuario", nombre: "Vestuario", icono: "shirt" },
  { id: "duchas", nombre: "Duchas", icono: "shower" },
  { id: "ayuda-medica", nombre: "Ayuda médica", icono: "medic" },
  { id: "parrilla", nombre: "Parrilla", icono: "grill" },
  { id: "aire-acondicionado", nombre: "Aire acondicionado", icono: "ac" },
  { id: "accesibilidad", nombre: "Accesibilidad", icono: "accessible" },
  { id: "cafeteria", nombre: "Cafetería / buffet", icono: "coffee" },
  { id: "camaras", nombre: "Cámaras de seguridad", icono: "camera" },
  { id: "gimnasio", nombre: "Gimnasio", icono: "gym" },
  { id: "pet-friendly", nombre: "Pet friendly", icono: "pet" },
  { id: "cambiador", nombre: "Cambiador de bebés", icono: "baby" },
  { id: "pago-tarjeta", nombre: "Pago con tarjeta", icono: "card" },
];

const ICON_BY_KEY: Record<string, LucideIcon> = {
  wifi: Wifi,
  parking: SquareParking,
  shirt: Shirt,
  shower: ShowerHead,
  medic: Cross,
  grill: Flame,
  ac: AirVent,
  accessible: Accessibility,
  coffee: Coffee,
  camera: Camera,
  gym: Dumbbell,
  pet: Dog,
  baby: Baby,
  card: CreditCard,
};

/** Ícono de fallback para amenities personalizados o claves desconocidas. */
export const DEFAULT_AMENITY_ICON: LucideIcon = Sparkles;

export function getAmenityIcon(icono: string): LucideIcon {
  return ICON_BY_KEY[icono] ?? DEFAULT_AMENITY_ICON;
}

export function amenityCatalogLabel(id: string): string | undefined {
  return AMENITIES_CATALOG.find((entry) => entry.id === id)?.nombre;
}

/** Genera un AmenityItem personalizado a partir de un texto libre cargado por el usuario. */
export function createCustomAmenity(nombre: string): AmenityItem {
  return {
    id: `custom-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`,
    nombre: nombre.trim(),
    icono: "custom",
    tipo: "custom",
  };
}

export function predefinedAmenityToItem(entry: AmenityCatalogEntry): AmenityItem {
  return { id: entry.id, nombre: entry.nombre, icono: entry.icono, tipo: "predefinido" };
}
